
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsTasteDialog extends Serenity.EntityDialog<CsTasteRow, any> {
        protected getFormKey() { return CsTasteForm.formKey; }
        protected getIdProperty() { return CsTasteRow.idProperty; }
        protected getLocalTextPrefix() { return CsTasteRow.localTextPrefix; }
        protected getNameProperty() { return CsTasteRow.nameProperty; }
        protected getService() { return CsTasteService.baseUrl; }
        protected getDeletePermission() { return CsTasteRow.deletePermission; }
        protected getInsertPermission() { return CsTasteRow.insertPermission; }
        protected getUpdatePermission() { return CsTasteRow.updatePermission; }

        protected form = new CsTasteForm(this.idPrefix);

        protected afterLoadEntity() {
            super.afterLoadEntity();

            var Tasteid = Q.tryFirst(CsSkuRow.getLookup().items,x => x.TasteId == this.entity.TasteId);
            if(Tasteid !=null){
                this.deleteButton.toggleClass('disabled', true);
               
            }
            var Plucheck = Q.tryFirst(CsPluRow.getLookup().items, x=> x.TasteId == this.entity.TasteId);            
            if (Plucheck != null) {
                this.deleteButton.toggleClass('disabled', true);
               
                
            }
        }
        
    }
}